import React from "react";

export class CookiePolicyIT extends React.Component {
    render() {
        return (
            <>
                <p>
                    Ultimo aggiornamento: <b>18/06/2026</b>
                    <br />
                    <br />
                </p>
                <p>
                    Il presente documento è stato redatto ai sensi del Regolamento UE 2016/679 (il "GDPR") per consentire agli utenti di comprendere quali cookie sono installati
                    quando utilizzano il sito web https://www.dedalus.com/be/en/our-offer/products/pacsonweb/ (il "Sito").
                </p>
                <h2>1. Titolare del trattamento e responsabile della protezione dei dati</h2>
                <p>
                    DH Healthcare GmbH, con sede legale in Konrad-Zuse-Platz 1-3, 53227 Bonn, Germany, è il titolare del trattamento dei dati personali (i Dati) degli utenti del
                    Sito Web raccolti utilizzando i cookie. Per qualsiasi richiesta è possibile scrivere a DH Healthcare GmbH all'indirizzo fisico sopra indicato o tramite
                    l'indirizzo e-mail.
                    <br />
                    <br />
                    DH Healthcare GmbH ha nominato un Responsabile della protezione dei dati ("DPO"), che può essere contattato all'indirizzo Dpo.belgium@dedalus.eu
                </p>
                <h2>2. Dati trattati da DH Healthcare GmbH</h2>
                <p>
                    L'applicazione sul sito prevede l'utilizzo di cookie, brevi stringhe di testo che i siti visitati inviano al browser dell'utente , dove vengono memorizzati per
                    essere poi trasmessi agli stessi siti web in occasione di visite successive. Nel corso della navigazione su un sito, l'utente potrebbe ricevere sul suocomputer
                    anche cookie di siti o di web server diversi da quello che lo sta visitando (c.d. cookie di "terze parti"). È possibile distinguere:
                    <br />
                    <br />
                    A. Cookie tecnici, che consentono di svolgere attività legate al funzionamento del Sito.
                    <br />
                    <br />
                    B. Cookie di profilazione, utilizzati per analizzare il comportamento degli utenti e, se necessario, per inviare messaggi pubblicitari in linea con le
                    preferenze manifestate dallo stesso nell'ambito della navigazione.
                    <br />
                    <br />
                    C. Archiviazione locale, che consente di svolgere attività connesse al funzionamento del Sito.
                </p>
                <p>
                    <br />
                    Questo Sito Web utilizza i seguenti cookie:
                </p>
                <h3>a) Cookie tecnici</h3>
                <table>
                    <thead>
                        <tr>
                            <th>Nome</th>
                            <th>Ospite</th>
                            <th>Categoria</th>
                            <th>Descrizione</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>__Hosts-FormsAuthentication</td>
                            <td>Dobco</td>
                            <td>Necessario</td>
                            <td>Autenticazione del portale DeepUnity PACSonWEB</td>
                        </tr>
                        <tr>
                            <td>__Hosts-Session</td>
                            <td>Dobco</td>
                            <td>Necessario</td>
                            <td>ID della sessione del portale DeepUnity PACSonWEB</td>
                        </tr>
                        <tr>
                            <td>Language</td>
                            <td>Dobco</td>
                            <td>Necessario</td>
                            <td>Registra la scelta della lingua non appena viene modificata manualmente (la lingua del browser viene utilizzata come standard).</td>
                        </tr>
                        <tr>
                            <td>Source</td>
                            <td>Dobco</td>
                            <td>Necessario</td>
                            <td>Portale clienti in cui si è effettuato l'accesso.</td>
                        </tr>
                        <tr>
                            <td>HidePatientLogin</td>
                            <td>Dobco</td>
                            <td>Necessario</td>
                            <td>Nasconde l'accesso paziente nella pagina di accesso.</td>
                        </tr>
                        <tr>
                            <td>LocalImageCaches</td>
                            <td>Dobco</td>
                            <td>Necessario</td>
                            <td>Registra le cache di immagini locali, collegate all'utente.</td>
                        </tr>
                        <tr>
                            <td>LastUserName</td>
                            <td>Dobco</td>
                            <td>Necessario</td>
                            <td>
                                Registra l'ultimo nome utente utilizzato per accedere al sistema. Viene utilizzato per precompilare il campo del nome utente al successivo accesso.
                            </td>
                        </tr>
                        <tr>
                            <td>UrlReferrer</td>
                            <td>Dobco</td>
                            <td>Necessario</td>
                            <td>
                                Registra l'URL della pagina da cui si è giunti al sistema. Viene utilizzato per reindirizzare l'utente a quella pagina dopo l'accesso, se non
                                proveniva dalla pagina di accesso.
                            </td>
                        </tr>
                        <tr>
                            <td>Dobco.AcceptedAllCookies </td>
                            <td>Dobco</td>
                            <td>Funzionale</td>
                            <td>Questo cookie viene impostato se si sceglie di consentire tutti i cookie e si registra quando è stato impostato.</td>
                        </tr>
                        <tr>
                            <td>Dobco.AcceptedNecessaryCookies</td>
                            <td>Dobco</td>
                            <td>Necessario</td>
                            <td>Questo cookie viene impostato se si sceglie di consentire solo i cookie necessari e si registra quando è stato impostato.</td>
                        </tr>
                        <tr>
                            <td>__Secure-UI-External-Login</td>
                            <td>Dobco</td>
                            <td>Necessario</td>
                            <td>
                                Salva lo stato durante un roundtrip di login esterno (quando si accede tramite un provider di identità esterno come ADFS). È necessario per motivi
                                di sicurezza per prevenire attacchi CSRF e replay.
                            </td>
                        </tr>
                        <tr>
                            <td>__Secure-UI-OIDC-Session</td>
                            <td>Dobco</td>
                            <td>Necessario</td>
                            <td>Mantiene l'utente connesso al provider di accesso DeepUnity PACSonWEB dopo un accesso riuscito.</td>
                        </tr>
                        <tr>
                            <td>__Secure-UI-Pending-Auth</td>
                            <td>Dobco</td>
                            <td>Necessario</td>
                            <td>
                                Memorizza temporaneamente la richiesta di accesso in sospeso mentre si viene reindirizzati alla pagina di accesso. È necessario per completare
                                l'accesso.
                            </td>
                        </tr>
                        <tr>
                            <td>__Secure-UI-Pending-2FA</td>
                            <td>Dobco</td>
                            <td>Necessario</td>
                            <td>
                                Trasporta temporaneamente lo stato dell'autenticazione a due fattori tra la fase di accesso e la fase di verifica. È necessario per completare
                                l'autenticazione a due fattori.
                            </td>
                        </tr>
                        <tr>
                            <td>__Secure-UI-2FA-Skip</td>
                            <td>Dobco</td>
                            <td>Necessario</td>
                            <td>
                                Ricorda che hai completato l'autenticazione a due fattori affinché non venga più richiesto un secondo fattore sullo stesso browser per un periodo
                                limitato.
                            </td>
                        </tr>
                        <tr>
                            <td>__Secure-UI-Authentication</td>
                            <td>Dobco</td>
                            <td>Necessario</td>
                            <td>Autenticazione del portale DeepUnity PACSonWEB per il provider di accesso.</td>
                        </tr>
                        <tr>
                            <td>__Secure-UI-Antiforgery</td>
                            <td>Dobco</td>
                            <td>Necessario</td>
                            <td>Protegge i moduli di accesso dagli attacchi di cross-site request forgery (CSRF).</td>
                        </tr>
                        <tr>
                            <td>__Secure-UI-BankId</td>
                            <td>Dobco</td>
                            <td>Necessario</td>
                            <td>
                                Salva lo stato durante un accesso con BankID (quando un paziente accede con BankID). Questo è necessario per motivi di sicurezza per prevenire
                                attacchi CSRF e di replay.
                            </td>
                        </tr>
                        <tr>
                            <td>__Secure-UI-Post-Logout-Parameters</td>
                            <td>Dobco</td>
                            <td>Necessario</td>
                            <td>
                                Ricorda come hai effettuato l'accesso, in modo che tu possa essere disconnesso anche presso quel provider di identità (BankID o eID / itsme) quando
                                esci.
                            </td>
                        </tr>
                        <tr>
                            <td>__Secure-UI-Pending-eID</td>
                            <td>Dobco</td>
                            <td>Necessario</td>
                            <td>
                                Salva lo stato durante un ciclo di accesso eID / itsme (quando un professionista sanitario accede con eID o itsme). Questo è necessario per motivi
                                di sicurezza per prevenire attacchi CSRF e di replay.
                            </td>
                        </tr>
                        <tr>
                            <td>__Secure-Last-Login</td>
                            <td>Dobco</td>
                            <td>Necessario</td>
                            <td>
                                Ricorda l'ultima modalità di accesso, in modo che l'esperienza di accesso possa essere personalizzata tra le applicazioni DeepUnity PACSonWEB
                                collegate.
                            </td>
                        </tr>
                    </tbody>
                </table>
                <h3>b) Cookie analytics/di profilazione</h3>
                <table>
                    <thead>
                        <tr>
                            <th>Nome</th>
                            <th>Ospite</th>
                            <th>Durata</th>
                            <th>Categoria</th>
                            <th>Descrizione</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>_GA</td>
                            <td>Google</td>
                            <td>2 anni</td>
                            <td>Analitico</td>
                            <td>Utilizzato per distinguere gli utenti.</td>
                        </tr>
                        <tr>
                            <td>_GID</td>
                            <td>Google</td>
                            <td>24 ore</td>
                            <td>Analitico</td>
                            <td>Utilizzato per distinguere gli utenti.</td>
                        </tr>
                        <tr>
                            <td>_GA_&lt;container_id&gt;</td>
                            <td>Google</td>
                            <td>2 anni</td>
                            <td>Analitico</td>
                            <td>Utilizzato per rendere persistente lo stato della sessione.</td>
                        </tr>
                    </tbody>
                </table>
                <h3>c) Archiviazione locale (Host: Dobco; Categoria: Necessario)</h3>
                <table>
                    <thead>
                        <tr>
                            <th>Nome</th>
                            <th>Descrizione</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>shownNews</td>
                            <td>L'ultima volta che avete aperto gli avvisi.</td>
                        </tr>
                        <tr>
                            <td>POWHomerBGuid</td>
                            <td>ID per l'utilizzo di HomeReading.</td>
                        </tr>
                        <tr>
                            <td>POW3SharingPrintSettings</td>
                            <td>Impostazioni preferite per la stampa di un numero di riferimento.</td>
                        </tr>
                        <tr>
                            <td>POW3SharingAnonDestinationSettings</td>
                            <td>Impostazioni preferite per la condivisione di uno studio con destinazioni anonime.</td>
                        </tr>
                        <tr>
                            <td>POW3SharingOtherDestinationSettings</td>
                            <td>Impostazioni preferite per la condivisione di uno studio con altre destinazioni.</td>
                        </tr>
                        <tr>
                            <td>printing_check_openByDefault</td>
                            <td>Impostazione preferita per la stampa di uno studio.</td>
                        </tr>
                        <tr>
                            <td>acceptedPOW3Cookies</td>
                            <td>Registra se l'informativa sui cookie è già stata mostrata nel progetto di registrazione dell'utente.</td>
                        </tr>
                        <tr>
                            <td>POW3LoginOption</td>
                            <td>Modalità di accesso (paziente/medico).</td>
                        </tr>
                        <tr>
                            <td>uniqueBrowserIdentifier</td>
                            <td>
                                Identifica in modo univoco il vostro browser all'interno di DeepUnity PACSonWEB. Viene utilizzato per determinare se viene richiesto o meno
                                l'inserimento di un OTP durante l'accesso.
                            </td>
                        </tr>
                        <tr>
                            <td>LastAudioOutVolume</td>
                            <td>Salva l'ultimo livello di uscita del volume audio utilizzato.</td>
                        </tr>
                        <tr>
                            <td>PreferredRecognitionLanguage</td>
                            <td>Salva la lingua di riconoscimento vocale preferita.</td>
                        </tr>
                        <tr>
                            <td>scalingFactorConfiguration</td>
                            <td>Salva il fattore di scala preferito e la risoluzione iniziale corrispondente.</td>
                        </tr>
                        <tr>
                            <td>dontShowPopupForNewsIds</td>
                            <td>Identifica i popup delle notizie che non si desidera più visualizzare.</td>
                        </tr>
                        <tr>
                            <td>DefaultFontSize</td>
                            <td>Salva la dimensione del carattere preferita nel report.</td>
                        </tr>
                        <tr>
                            <td>SeriesPickerPosition</td>
                            <td>Salva la posizione preferita del selettore di serie.</td>
                        </tr>
                        <tr>
                            <td>SeriesPickerWidth</td>
                            <td>Salva la larghezza preferita del selettore di serie.</td>
                        </tr>
                        <tr>
                            <td>lastUsedInputDevice</td>
                            <td>Salva l'ultimo dispositivo di input utilizzato durante la dettatura.</td>
                        </tr>
                        <tr>
                            <td>lastUsedOutputDevice</td>
                            <td>Salva l'ultimo dispositivo di output utilizzato durante la dettatura.</td>
                        </tr>
                        <tr>
                            <td>AgreedToUserConditions</td>
                            <td>Salva l'accettazione delle condizioni d'uso.</td>
                        </tr>
                        <tr>
                            <td>POW3PreferredEnvironmentUID / preferredEnvironmentUid</td>
                            <td>Salva l'ambiente preferito quando richiesto.</td>
                        </tr>
                        <tr>
                            <td>closedBrowserSupport</td>
                            <td>Salva la chiusura della finestra di dialogo del supporto del browser.</td>
                        </tr>
                        <tr>
                            <td>activeLoginTab</td>
                            <td>Salva la scheda di accesso selezionata.</td>
                        </tr>
                        <tr>
                            <td>FailedLoginVerification</td>
                            <td>Registra, per la sessione corrente del browser, che è già stata mostrata la notifica relativa ai tentativi di accesso falliti.</td>
                        </tr>
                    </tbody>
                </table>
                <p>
                    Sebbene i cookie tecnici necessari non possano essere rifiutati dall'utente del Sito, in quanto strettamente funzionali al Sito stesso, l'utente può scegliere
                    liberamente di accettare o rifiutare l'utilizzo dei cookie analytics, di profilazione e non strettamente necessari. L'utente può impostare e rivedere le proprie
                    scelte in merito ai cookie con la funzione "Modifica delle impostazioni dei cookie" disponibile sul sito web (Sezione "Legale”)
                </p>
                <h2>3. Finalità e base giuridicadel trattamento</h2>
                <p>
                    Con icookie vengono perseguiti i seguenti scopi:
                    <br />
                    <br />
                    3.1. Per consentire la navigazione del sito Webse la sua funzionalità fluida. La base giuridica del trattamento è la fornitura agli utenti di servizi connessi
                    al sito web e il legittimo interesse di Dedalus ad avere un sito web funzionale.
                    <br />
                    <br />
                    3.2 Per adempiere ad eventuali obblighi previsti da leggi, regolamenti o normativa comunitaria, ovvero per ottemperare a richieste delle autorità. La base
                    giuridica del trattamento è l'obbligo di Dedalus di rispettare la normativa inderogabile.
                    <br />
                    <br />
                    3.3 Analizzare il comportamento dell'utente ed eventualmente inviargli messaggi pubblicitari in linea con le preferenze manifestate dallo stesso durante la
                    navigazione. La base giuridica del trattamento in questo caso è il consenso dell'interessato.
                    <br />
                    <br />
                    3.4 Per le esigenze di difesa dei diritti di Dedalus nell'ambito di eventuali contenziosi, anche in sede giudiziale. La base giuridica del trattamento è il
                    legittimo interesse del Titolare a tutelare i propri diritti.
                    <br />
                    <br />
                    Il conferimento dei Dati è facoltativo, ma (salvo i casi di trattamento basato sul consenso) il mancato conferimento dei Dati impedisce al Titolaredi consentire
                    la navigazione del Sito
                </p>
                <h2>4. Destinatari dei Dati</h2>
                <p>
                    I Dati potranno essere comunicati:
                    <br />
                    <br />
                    (a) a soggetti terzi che abbiano necessità di svolgere specifiche attività in relazione ai Dati, in conformità alle finalità del trattamento, ovvero a fornitori
                    di servizi al Titolare.
                    <br />
                    (b) ad autorità, enti e/o soggetti ai quali i Dati devono essere comunicati, in forza di disposizioni cogenti di legge o contrattuali.
                    <br />
                    (c) in altre circostanze, come acquisizioni e vendite a potenziali società terze, quando prevediamo di vendere o trasferire parte o tutta la nostra attività.
                </p>
                <h2>5. Trasferimento dei Dati al di fuoridello Spazio Economico Europeo</h2>
                <p>
                    Per quanto riguarda l'eventuale trasferimento dei Dati verso Paesi non appartenenti allo Spazio Economico Europeo, il trattamento avverrà secondo una delle
                    modalità legalmente consentite e quindi mediante la selezione di destinatari stabiliti in Paesi ritenuti adeguati dalla Commissione Europea o mediante la
                    stipula di clausole contrattuali standard.
                </p>
                <h2>6. Conservazione dei dati</h2>
                <p>
                    I Dati saranno conservati solo per il tempo necessario agli scopi per cui sono stati raccolti, rispettando i principi di limitazione e minimizzazione della
                    conservazione. Più precisamente, i termini di durata dei cookie sono definiti nella precedente sezione 2. Per i Dati il cui trattamento è basato sul consenso
                    dell'interessato, si precisa che gli stessi saranno conservati fino alla revoca di tale consenso.
                </p>
                <h2>7. Diritti degli interessati</h2>
                <p>
                    In presenza dei presupposti legali pertinenti, l'interessato può chiedere al Titolare o al DPO l'accesso ai propri Dati, la rettifica o la cancellazione degli
                    stessi o di opporsi al loro trattamento, di chiedere la limitazione del trattamento nei casi previsti dall'articolo 18 GDPR, nonché di ottenere in modo
                    strutturato, formato comunemente usato, e leggibile da dispositivo automatico, dei dati che lo riguardano, nei casi previsti dall'articolo 20 GDPR.
                    <br />
                    <br />
                    Inoltre, l'utente ha il diritto di revocare in qualsiasi momento il consenso al trattamento, senza pregiudicare la liceità del trattamento effettuato dal
                    Titolare prima della revoca.
                    <br />
                    Le richieste vanno rivolte per iscritto al Titolare del trattamento ai recapiti sopra indicati.
                    <br />
                    <br />
                    In ogni caso, l'interessato può proporre reclamo al Garante per la Protezione dei Dati Personali qualora ritenga che il trattamento dei suoi Dati sia contrario
                    alle normative vigenti.
                </p>
            </>
        );
    }
}
